.scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.page {
  padding: var(--page-pad-top) var(--page-pad-x) 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
}

.back {
  width: 34px;
  height: 34px;
  flex: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-text-secondary);
}

.back:hover {
  background: var(--c-overlay);
  color: var(--c-text-primary);
}

.titleBlock {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.crumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--c-text-tertiary);
}

.crumbLink {
  color: var(--c-text-tertiary);
}

.crumbLink:hover {
  color: var(--c-text-primary);
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.title {
  font-size: var(--text-title);
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.subtitle {
  font-size: 12px;
  color: var(--c-text-tertiary);
  line-height: 1.45;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  font-size: var(--text-caption);
  color: var(--c-text-secondary);
}

.meta b {
  font-weight: 600;
  color: var(--c-text-primary);
}

.actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.grid {
  display: grid;
  gap: 16px;
  align-items: start;
  min-width: 0;
}

.stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;
}

.spacer {
  flex: 1;
}

.divider {
  display: block;
  height: 1px;
  background: var(--c-border);
}

.vdivider {
  display: block;
  width: 1px;
  height: 18px;
  background: var(--c-border);
}

@media (max-width: 1100px) {
  .grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }
}
